import React from "react";
import moment from "moment";
import { numberFormatter } from "../utility/Formatter";

export const createCreditRequestData = (
  data: any,
  creditRequest: any,
  creditTabs: "ORDER" | "CREDIT",
  creditImageFiles: string[] = [],
  onPreviewImage: (index: number) => void,
) => {
  const formatDate = (date?: string) => (date ? moment(date).format("DD/MM/YYYY") : "-");

  const formatMoney = (value?: number) => `${numberFormatter(value ?? 0, 2)} ฿`;

  const formatPercent = (value?: number) => `${numberFormatter(value ?? 0, 2)}%`;

  const renderImages =
    creditImageFiles.length > 0 ? (
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {creditImageFiles.map((img, index) => (
          <img
            key={index}
            src={img}
            width={80}
            height={80}
            style={{
              objectFit: "cover",
              borderRadius: 6,
              cursor: "pointer",
              border: "1px solid #eee",
            }}
            onClick={() => onPreviewImage(index)}
          />
        ))}
      </div>
    ) : null;

  return {
    customerDetails: {
      customerInfo: [
        {
          label: "รหัสร้านค้า",
          value: data?.customerNo ?? "-",
        },
        {
          label: "ชื่อร้านค้า",
          value: data?.customerName ?? "-",
        },
        {
          label: "เลขนิติบุคคล",
          value: data?.taxNo ?? "-",
        },
        {
          label: "ชื่อเจ้าของร้าน",
          value: data?.ownerFirstname
            ? `${data?.ownerFirstname} ${data?.ownerLastname ?? ""}`
            : "-",
        },
        {
          label: "เบอร์โทร",
          value: data?.telephone ?? "-",
        },
        {
          label: "เขต",
          value: data?.zone ?? "-",
        },
      ],

      creditRequestInfo: [
        {
          label: creditTabs === "ORDER" ? "วันที่สั่งซื้อ" : "วันที่ส่งคำขอ",
          value: formatDate(creditRequest?.requestDate),
        },
        {
          label: creditTabs === "ORDER" ? "รหัสคำสั่งซื้อ" : "รหัสคำขอ",
          value: creditTabs === "ORDER" ? data?.orderNo : creditRequest?.requestNo,
        },
        {
          label: "ผู้ขอวงเงิน",
          value: creditRequest?.userRequest ?? "-",
        },

        ...(creditTabs === "CREDIT"
          ? [
              {
                label: "ระยะเวลาการใช้งาน",
                value: `${formatDate(creditRequest?.startDate)} - ${formatDate(
                  creditRequest?.endDate,
                )}`,
              },
            ]
          : []),

        {
          label: "เหตุผลการขอ",
          value: creditRequest?.remarkRequest ?? "-",
        },
        ...(renderImages
          ? [
              {
                label: "",
                value: renderImages,
              },
            ]
          : []),
      ],

      creditLimitInfo: {
        details: [
          {
            label: "วงเงินเกินสะสม",
            value: `${formatMoney(data?.arOverCredit)} (${formatPercent(
              data?.arOverCreditPercent || 0,
            )})`,
          },
          {
            label: creditTabs === "ORDER" ? "คำสั่งซื้อนี้ / วงเงินที่ขอ" : "วงเงินที่ขอ",
            value: `${formatMoney(creditRequest?.creditLimitRequest)} (${formatPercent(
              creditRequest?.creditLimitRequestPercent || 0,
            )})`,
          },
        ],

        summary: [
          {
            label: "รวมวงเงินเกิน",
            value: `${formatMoney(data?.creditLimitTotal)} (${formatPercent(
              data?.creditLimitTotalPercent || 0,
            )})`,
            sum: true,
          },
        ],
      },
    },
  };
};
